var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BixLink',{directives:[{name:"track-click",rawName:"v-track-click:post_job_topnav_button",arg:"post_job_topnav_button"}],staticClass:"menu-link-button",attrs:{"href":_vm.postJobUrl}},[_vm._v("\n  Post Job\n")])}
var staticRenderFns = []

export { render, staticRenderFns }